export default "__VITE_ASSET__CVBUwnWG__"